import {Component, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {PageEvent} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {UserI} from '../../../../interfaces/user.interface';
import {AppService} from '../../../../../../app.service';
import {RouterService} from '../../../../../../core/services/router.service';
import {Pager} from '../../../../interfaces/pager';
import {UserFind} from '../../../../interfaces/user-find';
import {DialogService} from '../../../../../../core/services/dialog.service';
import {CreateUserDialogComponent} from './components/create-user-dialog/create-user-dialog.component';

@Component({
  selector: 'app-user-search',
  templateUrl: './user-search.component.html',
  styleUrls: ['./user-search.component.scss']
})
export class UserSearchComponent implements OnInit {

  users: UserI[] = null;

  suggestions: UserI[] = null;
  searchTimeout = null;

  constructor(
    public fb: FormBuilder,
    public app: AppService,
    public router: RouterService,
    public dialog: DialogService) {
  }

  usersDataSource = null;

  displayedColumns: string[] = [
    'icon',
    'given_name',
    'family_name',
    'email',
    'email_verified',
    'entry',
    'valid',
    'edit',
  ];

  columns = [
    {value: 'email', title: 'E-Mail'},
    {value: 'name', title: 'Name'},
    {value: 'kdnr', title: 'Kdnr'},
    {value: 'contract_id', title: 'Vertragsnummer'},
    {value: 'any', title: 'Alle'},
  ];

  pager: Pager = {
    length: null,
    pageSize: 10,
    pageIndex: 0,
    sortCol: null,
    sortOrder: null
  };

  pageSizeOptions: number[] = [5, 10, 25, 100];

  public filterForm = this.fb.group({
    input: this.fb.control(''),
    column: this.fb.control('any'),
  });

  ngOnInit(): void {
    this.loadScopes();
    this.showLastSearch();
  }

  submit() {
    this.userFind();
  }

  async showLastSearch() {
    await this.app.storage.get('users_last_search').then((params: UserFind) => {
      if (params) {
        this.filterForm.get('input').setValue(params.input);
        this.filterForm.get('column').setValue(params.column);
        this.pager = params.pager;
      }
    });

    if (this.app.searchResults) {
      this.users = this.app.searchResults.found;
      this.pager.length = this.app.searchResults.total;
      this.usersDataSource = new MatTableDataSource(this.users);
    }
  }

  reset() {
    this.filterForm.get('input').setValue('');
    this.filterForm.get('column').setValue('any');
    this.users = null;
    this.app.searchResults = null;
    this.pager.pageIndex = 0;
  }

  liveSearch() {
    const values = this.filterForm.value;
    const inp = values.input;
    clearTimeout(this.searchTimeout);

    if (inp.length >= 4) {
      const params: UserFind = {input: inp, column: values.column, pager: this.pager};
      this.searchTimeout = setTimeout(() => {
        this.app.usersFind(params).then(data => {
          if (data.found && data.found.length) {
            this.suggestions = data.found;
          }
        });
      }, 850);
    } else {
      this.suggestions = null;
    }
  }

  closeSuggestions() {
    setTimeout(() => {
      this.suggestions = null;
    }, 500)
  }

  async userFind() {
    this.app.dialog.loader({
      title: 'Suche nach Benutzern'
    });
    const values = this.filterForm.value;
    const params: UserFind = {input: values.input, column: values.column, pager: this.pager};
    this.saveLastSearch(params);
    this.users = await this.app.usersFind(params).then(data => {
      // console.log(data);
      this.app.dialog.closeLoader();
      this.pager.length = data.total;
      this.usersDataSource = new MatTableDataSource(data.found);
      return data.found;
    }).catch((err) => {
      this.app.dialog.closeLoader();
      return null;
    });
  }

  open(user: UserI) {
    this.router.navigateByUrl('/admin/users/edit/' + user.id);
  }

  addUser() {
    this.dialog.open(CreateUserDialogComponent, {data: {user_id: ''}, minWidth: '50%'});
  }

  switchPage(e: PageEvent) {
    this.pager.pageIndex = e.pageIndex;
    this.pager.pageSize = e.pageSize;
    // console.log(e, this.pager);
    this.userFind();
  }

  sortResults(sort: any) {
    if (sort.active && sort.direction) {
      this.pager.sortCol = sort.active;
      this.pager.sortOrder = sort.direction;
      this.userFind();
    }
  }

  saveLastSearch(params: UserFind) {
    this.app.storage.set('users_last_search', params);
  }

  loadScopes() {
    if (!this.app.scopes) {
      this.app.getScopes();
    }
  }
}
